import {
    changeFieldProperty, setDataList, setFieldEdition, setFieldListOptions,
    setFieldVisibility
} from "../../../../../apps/KpModule/actions";
import _ from "lodash";
import {generateFetchFieldListAction} from "../../../../../apps/KpModule/actions/api";
import {TypeOfLiberalityRecordObjects} from "../../staticEntities";
import {getDataListList} from "../../../../../apps/KpModule/selectors";
import {calculateNetForecast, getFieldsByPath} from "../utils";
import {ObjectId} from "bson";

export const module_ = {
    object: 'AssetInfos',
    name: 'LiberalityAsset',
    filters: ['byStatus'],
    tKey: 'Bien',
    category: {
        path: 'menuTitle_liberalities',
        icon: 'testament'
    },
    formSections: [
        {
            id: 'communDocuments',
            tKey: "Pièces communes et spécifiques du bien",
            defaultCollapsed: true,
            //color: "rgb(252, 185, 0)"
        },
        {
            id: 'history',
            tKey: "Historique des modifications",
            defaultCollapsed: false,
        }
    ],
    viewMap: {
        dt: [
            {path: 'applicationNumber', tKey: 'N° dossier', initiallyNotVisible: true},
            {path: 'presentationDate', tKey: 'présentation', initiallyNotVisible: true},
            {path: 'fileStatus', display: 'name', tKey: 'Statut dossier', type: 'status', fieldPath: ['id', 'name', 'bStyle'], initiallyNotVisible: true},
            {path: 'fileDecisionDate', tKey: 'Date décision', initiallyNotVisible: true},
            {path: 'administrator', tKey: 'Gestionnaire'},
            {path: 'typeOfFile', tKey: 'Nature dossier', initiallyNotVisible: true},
            {path: 'benefactor', tKey: 'Bienfaiteur(rice)'},
            {path: 'beneficiaries', tKey: 'Bénéficiaire(s)', initiallyNotVisible: true},
            {path: 'typeOfProperty', tKey: 'Catégorie / Nature du bien', initiallyNotVisible: true},
            {path: 'identifier'},
            {path: 'estimatedAssetValue', initiallyNotVisible: true},
            {path: 'assetLiabilities', initiallyNotVisible: true},
            {path: 'estimatedAssetNetValue'},
            {path: 'beneficiariesShareInAssetEstimatedValue', initiallyNotVisible: true},
            {path: 'beneficiariesShareInAssetLiabilities', initiallyNotVisible: true},
            {path: 'beneficiariesOwnLiabilities', initiallyNotVisible: true},
            {path: 'beneficiariesShareInLiberalityRecordActsFees', initiallyNotVisible: true},
            'estimatedBeneficiariesNetValue',
            'CNDAShareInEstimatedBeneficiariesNetValue',
            {path: 'status', tKey: 'statut bien'},
            {path: 'updatedBy', tKey: 'MAJ par'},
            {path: 'updatedAt', tKey: 'MAJ le'},
        ],
        form: {
            fields: [
                {
                    path: 'liberalityRecord',
                    widthClassName: "col-xs-12 col-sm-6",
                    required: true,
                    display: 'fileApplicationNumberAndBenefactor',
                    fieldPath: ['id', 'fileApplicationNumberAndBenefactor', 'administrator.id', 'administrator.fullName', 'typeOfFile.id', 'typeOfFile.fullName', 'benefactor'],
                    editable: false,
                    subscriptions: {
                        onChange: (newValue, oldValue, { module, store }) => {
                            const state = store.getState()
                            const objectMode = state.ui.objectMode
                            if (objectMode === 'newObject' && newValue) {
                                module.viewMap.form.fields.find(f => f.path === 'administrator')?.setValue(newValue.administrator?.fullName)
                                module.viewMap.form.fields.find(f => f.path === 'typeOfFile')?.setValue(newValue.typeOfFile?.fullName)
                                module.viewMap.form.fields.find(f => f.path === 'benefactor')?.setValue(newValue.benefactor)
                            }
                        }
                    }
                },
                {
                    path: 'typeOfFile',
                    tKey: 'Nature dossier',
                    disabled: true,
                    widthClassName: "col-xs-12 col-sm-6",
                    subscriptions: {
                        onChange: (newValue, oldValue, { module, store, formInitialize, getObjectSuccessAction }) => {
                            const state = store.getState()
                            const objectMode = state.ui.objectMode
                            const newValue2 = TypeOfLiberalityRecordObjects.find(obj => obj.fullName === newValue)

                            const isLegs = newValue2?.id === 'legs'
                            const isLifeInsurance = newValue2?.id === 'lifeInsurance'
                            const isDonationOrGiftsOnInheritance = ['donations', 'giftsOnInheritance'].includes(newValue2?.id)

                            const getField = path => module.viewMap.form.fields.find(f => f.path === path)

                            store.dispatch(setFieldVisibility(getField('typeOfProperty').id, !isLifeInsurance))

                            const typeOfPropertyDisplay = isLegs ? 'category' : 'natureOfProperty'
                            store.dispatch(changeFieldProperty(getField('typeOfProperty').id, 'tKey', typeOfPropertyDisplay))

                            const options = getDataListList(state, 'm-C-liberalityAsset.AssetInfos_typeOfProperty')
                            const filteredOptions = options.filter(option => {
                                return isLegs
                                    ? option.category
                                    : isDonationOrGiftsOnInheritance
                                        ? option.natureOfProperty
                                        : false
                            })
                            store.dispatch(setFieldListOptions(getField('typeOfProperty').id, _.map(filteredOptions, 'id')))

                            const distField = module.viewMap.form.fields.find(f => f.path === 'distribution')
                            const ownLiabilitiesFormField = distField.viewMap.form.fields.find(f => f.path === 'beneficiaryOwnLiabilities')
                            const qualificationListField = distField.viewMap.dt.fields.find(f => f.path === 'qualification')
                            const qualificationFormField = distField.viewMap.form.fields.find(f => f.path === 'qualification')

                            store.dispatch(setFieldVisibility(ownLiabilitiesFormField.id, !isLifeInsurance))
                            store.dispatch(setFieldVisibility(qualificationListField.id, isLegs))
                            store.dispatch(setFieldVisibility(qualificationFormField.id, isLegs))

                            const category = module.viewMap.form.fields.find(f => f.path === 'typeOfProperty')?.getValue()?.id || null
                            store.dispatch(
                                generateFetchFieldListAction(
                                    "m-C-liberalityAsset.AssetInfos_status",
                                    store.getState,
                                    { data: { fileNature: newValue2, category } }
                                )
                            )

                            if (objectMode === 'newObject') {
                                store.dispatch(
                                    generateFetchFieldListAction(
                                        "m-C-liberalityAsset.FileList_fileCategory",
                                        store.getState,
                                        { data: { fileNature: newValue2, category } }
                                    )
                                ).then((response) => {
                                    const fileCategories = response.data || []
                                    const fileListField = module.viewMap.form.fields.find(field => field.path === 'filesList')
                                    const necessaryCategories = fileCategories.filter(category => {
                                        const valueForThisType = category.fileConfigurations.find(config => config.typeOfLiberalityRecord.id === newValue2?.id)
                                        return valueForThisType?.fileStatus.id === 'necessary'
                                    })
                                    fileListField.setValue(necessaryCategories.map(fileCategory => {
                                        return {
                                            id: new ObjectId(),
                                            fileCategory: {
                                                id: fileCategory.id,
                                                title: fileCategory.title,
                                            },
                                            files: [],
                                            noDeleteButtonAccess: true,
                                            filesNumber: 0
                                        }
                                    }))
                                })
                            }
                        }
                    }
                },
                {path: 'administrator', tKey: 'Gestionnaire', disabled: true, widthClassName: "col-xs-12 col-sm-6"},
                {path: 'benefactor', tKey: 'Bienfaiteur(rice)', disabled: true, widthClassName: "col-xs-12 col-sm-6"},
                {
                    path: 'typeOfProperty',
                    tKey: 'Catégorie / Nature du bien',
                    fieldPath: ['id', 'name', 'category', 'natureOfProperty'],
                    required: true,
                    editable: false,
                    widthClassName: "col-xs-12 col-sm-6",
                    subscriptions: {
                        onChange: (newValue, oldValue, { module, store }) => {
                            const state = store.getState()
                            const objectMode = state.ui.objectMode
                            if (objectMode === 'newObject') {
                                const typeOfFileField = module.viewMap.form.fields.find(f => f.path === 'typeOfFile')
                                const fileNature = TypeOfLiberalityRecordObjects.find(obj => obj.fullName === typeOfFileField?.getValue())
                                store.dispatch(
                                    generateFetchFieldListAction(
                                        "m-C-liberalityAsset.AssetInfos_status",
                                        store.getState,
                                        { data: { fileNature: fileNature, category: newValue?.id } }
                                    )
                                )
                                store.dispatch(
                                    generateFetchFieldListAction(
                                        "m-C-liberalityAsset.FileList_fileCategory",
                                        store.getState,
                                        { data: { fileNature, category: newValue?.id } }
                                    )
                                ).then((response) => {
                                    const fileCategories = response.data || []
                                    const fileListField = module.viewMap.form.fields.find(f => f.path === 'filesList')
                                    const necessaryCategories = fileCategories.filter(cat => {
                                        const valueForThisType = cat.fileConfigurations.find(config => config.typeOfLiberalityRecord.id === fileNature?.id)
                                        return valueForThisType?.fileStatus.id === 'necessary'
                                    })
                                    fileListField.setValue(necessaryCategories.map(fileCategory => ({
                                        id: new ObjectId(),
                                        fileCategory: { id: fileCategory.id, title: fileCategory.title },
                                        files: [],
                                        noDeleteButtonAccess: true,
                                        filesNumber: 0
                                    })))
                                })
                            }
                        }
                    }
                },
                {
                    path: 'identifier',
                    widthClassName: "col-xs-12 col-sm-6",
                    required: true
                },
                {path: 'comment', type: 'richTextEditor'},
                {
                    path: 'estimatedAssetValue',
                    minValue: 0,
                    default: 0,
                    required: true,
                    widthClassName: "col-xs-12 col-sm-6",
                    /*subscriptions: {
                        onChange: (newValue, oldValue, { module }) => {
                            const f = getFieldsByPath(module.viewMap.form.fields, ['assetLiabilities', 'estimatedAssetNetValue'])
                            f.estimatedAssetNetValue.setValue((newValue ?? 0) - (f.assetLiabilities?.getValue() ?? 0))
                        }
                    }*/
                },
                {
                    path: 'assetLiabilities',
                    minValue: 0,
                    default: 0,
                    required: true,
                    widthClassName: "col-xs-12 col-sm-6",
                    /*subscriptions: {
                        onChange: (newValue, oldValue, { module }) => {
                            const f = getFieldsByPath(module.viewMap.form.fields, ['estimatedAssetValue', 'estimatedAssetNetValue'])
                            f.estimatedAssetNetValue.setValue((f.estimatedAssetValue?.getValue() ?? 0) - (newValue ?? 0))
                        }
                    }*/
                },
                {
                    path: 'estimatedAssetNetValue',
                    default: 0,
                    widthClassName: "col-xs-12 col-sm-6",
                    disabled: true,
                    /*subscriptions: {
                        onChange: (newValue, oldValue, { module }) => {
                            const distField = module.viewMap.form.fields.find(f => f.path === 'distribution')
                            const f = getFieldsByPath(distField.viewMap.form.fields, ['share', 'beneficiaryOwnLiabilities', 'estimatedBeneficiaryNetValue'])
                            f.estimatedBeneficiaryNetValue.setValue((newValue ?? 0) * (f.share?.getValue() ?? 0) / 100 - (f.beneficiaryOwnLiabilities?.getValue() ?? 0))
                        }
                    }*/
                },
                {path: 'beneficiariesOwnLiabilities', widthClassName: "col-xs-12 col-sm-6"},
                {path: 'beneficiariesShareInLiberalityRecordActsFees', widthClassName: "col-xs-12 col-sm-6"},
                {path: 'CNDAShareInEstimatedBeneficiariesNetValue', widthClassName: "col-xs-12 col-sm-6"},
                {
                    path: 'distribution',
                    tKey: 'Répartitions',
                    viewMap: {
                        dt: [
                            {path: 'confFor', tKey: 'Pour'},
                            {path: 'beneficiary', display: 'zipCodeAndName'},
                            {path: 'qualification', tKey: 'Qualification'},
                            {path: 'share', tKey: 'Quote-part'},
                            {path: 'beneficiaryShareInAssetEstimatedValue', initiallyNotVisible: true},
                            {path: 'beneficiaryShareInAssetLiabilities', initiallyNotVisible: true},
                            {path: 'beneficiaryOwnLiabilities', initiallyNotVisible: true},
                            {path: 'actsFeesSupported', initiallyNotVisible: true},
                            {path: 'beneficiaryShareInLiberalityRecordActsFees', initiallyNotVisible: true},
                            {path: 'estimatedBeneficiaryNetValue',},
                            {path: 'CNDAShareInEstimatedBeneficiaryNetValue'},
                        ],
                        form: [
                            {path: 'confFor', tKey: 'CONF. DEFENSE DE L’ANIMAL POUR'},
                            {path: 'beneficiary', display: 'zipCodeAndName', filters: ['isAssociation'], widthClassName: "col-xs-12 col-sm-6"},
                            {path: 'qualification', required: true, widthClassName: "col-xs-12 col-sm-6"},
                            {
                                path: 'share',
                                tKey: 'Quote-part',
                                required: true,
                                default: 0,
                                minValue: 0,
                                maxValue: 100,
                                widthClassName: "col-xs-12 col-sm-6",
                                /*subscriptions: {
                                    onChange: (newValue, oldValue, { module }) => {
                                        const f = getFieldsByPath(module.viewMap.form.fields, ['estimatedAssetNetValue'])
                                        const distField = module.viewMap.form.fields.find(d => d.path === 'distribution')
                                        const g = getFieldsByPath(distField.viewMap.form.fields, ['beneficiaryOwnLiabilities', 'estimatedBeneficiaryNetValue'])
                                        g.estimatedBeneficiaryNetValue.setValue((f.estimatedAssetNetValue?.getValue() ?? 0) * (newValue ?? 0) / 100 - (g.beneficiaryOwnLiabilities?.getValue() ?? 0))
                                    }
                                }*/
                            },
                            {
                                path: 'beneficiaryOwnLiabilities',
                                required: true,
                                default: 0,
                                widthClassName: "col-xs-12 col-sm-6",
                                /*subscriptions: {
                                    onChange: (newValue, oldValue, { module }) => {
                                        const f = getFieldsByPath(module.viewMap.form.fields, ['estimatedAssetNetValue'])
                                        const distField = module.viewMap.form.fields.find(d => d.path === 'distribution')
                                        const g = getFieldsByPath(distField.viewMap.form.fields, ['share', 'estimatedBeneficiaryNetValue'])
                                        g.estimatedBeneficiaryNetValue.setValue((f.estimatedAssetNetValue?.getValue() ?? 0) * (g.share?.getValue() ?? 0) / 100 - (newValue ?? 0))
                                    }
                                }*/
                            },
                            {path: 'actsFeesSupported', widthClassName: "col-xs-12 col-sm-6"}
                        ],
                    }
                },
                {
                    path: 'liberalityRecordDocumentsList',
                    tKey: 'Pièces communes',
                    section: 'communDocuments',
                    disabled: true,
                    type: 'accordion',
                    viewMap: {
                        dt: [
                            {path: 'fileCategory.title', tKey: 'title'},
                            {path: 'filesNumber'},
                        ],
                        form: [
                            {path: 'fileCategory.title', tKey: 'title'},
                            {
                                path: 'files',
                                type: 'simpleFiles'
                            },
                            {path: 'filesNumber', hidden: true},
                        ]
                    }
                },
                {
                    path: 'filesList',
                    tKey: 'Pièces spécifiques',
                    section: 'communDocuments',
                    removable: true,
                    viewMap: {
                        dt: [
                            {path: 'fileCategory', tKey: 'title', display: 'title'},
                            {path: 'filesNumber'},
                            {path: 'noDeleteButtonAccess', hidden: true},
                        ],
                        form: [
                            {
                                path: 'fileCategory',
                                editable: false,
                                tKey: 'title',
                                display: 'title',
                                fieldPath: ['id', 'title', 'fileConfigurations'],
                                filters: ['getNecessaryOrUsefulByFileNatureAndExcludeAlreadyUsed'],
                                warnIfNotFound: false
                            },
                            {
                                path: 'files',
                                type: 'simpleFiles',
                                fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'],
                                subscriptions: {
                                    onChange: (newValue, oldValue, { module }) => {
                                        const fileListField = module.viewMap.form.fields.find(field => field.path === 'filesList')
                                        const filesNumberField = fileListField.viewMap.form.fields.find(field => field.path === 'filesNumber')
                                        filesNumberField.setValue(newValue?.length || 0)
                                    }
                                }
                            },
                            {path: 'noDeleteButtonAccess', hidden: true, default: false},
                            {path: 'filesNumber', hidden: true, default: 0},
                        ]
                    },
                    subscriptions: {
                        onChange: (newValue, oldValue, { module, store }) => {
                            if (newValue) {
                                const typeOfFileField = module.viewMap.form.fields.find(field => field.path === 'typeOfFile')
                                const fileNature = TypeOfLiberalityRecordObjects.find(obj => obj.fullName === typeOfFileField.getValue())
                                const category = module.viewMap.form.fields.find(f => f.path === 'typeOfProperty')?.getValue()?.id || null

                                store.dispatch(
                                    generateFetchFieldListAction(
                                        "m-C-liberalityAsset.FileList_fileCategory",
                                        store.getState,
                                        {
                                            data: {
                                                fileNature,
                                                category,
                                                alreadyUsedIds: newValue.map(file => file.fileCategory.id),
                                            }
                                        }
                                    )
                                )
                            }
                        }
                    }
                },
                {path: 'conversations', tKey: 'interactionZone'},
                {
                    path: 'status',
                    tKey: 'statut bien',
                    required: true,
                    display: 'name',
                    filters: ['getStatusForFileTypeAndCategory']
                },
                {
                    path: 'distributionHistory',
                    tKey: 'Historique de répartition',
                    section: 'history',
                    disabled: true,
                    type: 'accordion',
                    defaultSortBy: 'updatedAt',
                    defaultSortDirection: 'ASC',
                    viewMap: {
                        dt: [
                            {path: 'updatedAt', tKey: 'MAJ le'},
                            {path: 'updatedBy.name', tKey: 'MAJ par'},
                            {path: 'beneficiary.zipCodeAndName', tKey: 'Bénéficiaire'},
                            {path: 'changedFields', tKey: 'modifications', type: 'objectArray', display: 'name', translate: true},
                            {path: 'snapshot.assetInfos.estimatedAssetValue', tKey: 'estimatedAssetValue'},
                            {path: 'snapshot.assetInfos.assetLiabilities', tKey: 'assetLiabilities'},
                            {path: 'snapshot.beneficiaryOwnLiabilities', tKey: 'beneficiaryOwnLiabilities'},
                            {path: 'snapshot.assetInfos.status.name', tKey: 'status'},
                        ]
                    }
                },
            ]
        }
    }
}
